<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  headingLevel: Number
})

// Callers can forward an out-of-range or fractional level (e.g. a mis-clamped
// computation); normalize before building the tag name so this never emits
// anything other than a real h1-h6 element.
const clampedHeadingLevel = computed((): number => {
  const level = props.headingLevel
  return typeof level === 'number' && Number.isInteger(level)
    ? Math.min(Math.max(level, 1), 6)
    : 2
})
</script>
<template>
  <component :is="`h${clampedHeadingLevel}`" v-bind="$attrs">
    <slot></slot>
  </component>
</template>
